import { render } from "./HomeView.vue?vue&type=template&id=371e3d80"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\smart\\OneDrive\\Desktop\\Final Projects\\pet-shelter - global\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__